module.exports = __webpack_public_path__ + "static/media/coderscave_white.7fc70aa1.png";